import { render, staticRenderFns } from "./InterBtnBox.vue?vue&type=template&id=32103c5f&scoped=true&"
import script from "./InterBtnBox.vue?vue&type=script&lang=js&"
export * from "./InterBtnBox.vue?vue&type=script&lang=js&"
import style0 from "./InterBtnBox.vue?vue&type=style&index=0&id=32103c5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32103c5f",
  null
  
)

export default component.exports